import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import decodeTokenAndGetUserId from "../../utils/decodedToken";
import { addToCart, setCookie } from "../../utils/cookieUtils";
import axiosInstance from "../../utils/axiosInstance";

export default function Singleproductscomponent() {
  const navigate = useNavigate();
  const [quantity, setQuantity] = useState(1);
  const [formData, setFormData] = useState({
    addEgg: false,
    cakeImage: "",
    messageOnCake: "",
  });

  const handleIncrement = () => {
    setQuantity((prevQuantity) => prevQuantity + 1);
  };
  
  const handleDecrement = () => {
    if (quantity > 1) {
      setQuantity((prevQuantity) => prevQuantity - 1);
    }
  };
  const { id } = useParams();
  const [product, setProduct] = useState(null);

  useEffect(() => {
    // Fetch product from the API
    
    axiosInstance.get(`/api/products/get-product/${id}`)

      .then((response) => {
  
        // Assuming data is an array of cakes with a "category" property
        setProduct(response.data);
      })

      .catch((error) => console.error("Error fetching product:", error));
  }, [id]);

  const handleBuyClick = () => {
    if (!product) {
      console.error("Product data is not available yet.");
      return;
    }

    // Check if the user ID is available in local storage
    const token = localStorage.getItem("token");
    const userId = token ? decodeTokenAndGetUserId(token) : null;

    // Pass the product id as a parameter to the /cart page
    addToCart(userId, id, quantity);

    if (product.iscake) {
      addToCart(userId, id, quantity, formData);
      navigate("/cart");
    }
    navigate("/cart");
  };

  return (
    <div>
      <div className="mt-10">
        <section className="text-gray-600 body-font overflow-hidden">
          <div className="container px-5 py-24 mx-auto">
            {product && (
              <div key={product.id} className="lg:w-4/5 mx-auto flex flex-wrap">
                <div className="lg:w-1/2 w-full lg:pr-10 lg:py-6 mb-6 lg:mb-0">
                  <h2 className="text-sm title-font tracking-widest font-heading text-amber-500">
                    {product.iscake}
                  </h2>
                  <h1 className="text-3xl title-font font-medium font-heading text-amber-500 mb-4">
                    {product.name}
                  </h1>
                  <div className="flex mb-4">
                    <p className="flex-grow text-indigo-500 border-b-2 border-indigo-500 py-2 text-lg px-1">
                      {product.category}
                    </p>
                    <h2 className="text-sm title-font tracking-widest font-heading text-amber-500">
                      {new Date(product.addedAt).toLocaleDateString()}

                    </h2>
                  </div>

                 

                  {product.iscake && (
                    <div>
                      <p className="font-semibold font-heading"> Ingredients:  <span className="font-light"> {product.ingredients} </span>  </p>
                      {/* Add Birthday Message */}
                      <div className="form-group p-2">
                        <label htmlFor="messageOnCake">
                          Add Birthday Message:
                        </label>
                        <br />
                        <input
                          className="border border-black p-1 w-full"
                          type="text"
                          id="messageOnCake"
                          value={formData.messageOnCake}
                          placeholder="Happy Birthday..."
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              messageOnCake: e.target.value,
                            });
                          }}
                        />
                      </div>

                      {/* Add Egg */}
                      <div className="form-group p-2">
                        <input
                          className="text-lg"
                          type="checkbox"
                          checked={formData.addEgg}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              addEgg: e.target.checked,
                            });
                          }}
                        />
                        <label className="ml-2">Add Egg</label>
                      </div>

                      {/* Make Sugarless */}
                      <div className="form-group p-2">
                        <input
                          type="checkbox"
                          checked={formData.makeSugarless}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              makeSugarless: e.target.checked,
                            });
                          }}
                        />
                        <label className="ml-2">Make Sugarless</label>
                      </div>

                      {/* Cake Image */}
                      <div className="form-group p-2">
                        <label htmlFor="cakeImage" className="block  mb-2">
                          Want to add an image on the cake?
                        </label>
                        <label
                          htmlFor="cakeImage"
                          className="flex items-center cursor-pointer"
                        >
                          <span className="mr-2 bg-amber-500 text-sm text-white py-1 px-2 rounded-md hover:bg-blue-600 transition duration-300">
                            Choose File
                          </span>
                          <span className="text-gray-600">
                            {formData.cakeImage
                              ? formData.cakeImage.name
                              : "No file selected"}
                          </span>
                          <input
                            type="file"
                            id="cakeImage"
                            className="hidden"
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                cakeImage: e.target.files[0],
                              });
                            }}
                          />
                        </label>
                      </div>
                    </div>
                  )}

                  <div className="flex border-t border-b mb-6 border-gray-200 py-2">
                    <span className="text-gray-500">Quantity</span>
                    <div className="flex ml-auto">
                      <button
                        className="bg-amber-500 text-white px-3 py-1 rounded-l-md hover:bg-green-600 transition duration-300"
                        onClick={handleDecrement}
                      >
                        -
                      </button>
                      <span className="mx-2 bg-gray-200 px-3 py-1 text-gray-900">
                        {quantity}
                      </span>
                      <button
                        className="bg-amber-500 text-white px-3 py-1 rounded-r-md hover:bg-green-600 transition duration-300"
                        onClick={handleIncrement}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  <div className="flex">
                    <span className="title-font font-medium text-2xl text-red-500">
                      NPR: {product.price}
                    </span>

                    {product.discountprice && (

                    <span className="title-font font-medium text-2xl text-red-500">
                      {product.discountprice}
                    </span>
                     )}
                    
                    {/* For cake  */}

                    <button
                      className="rounded-full w-20 h-20 bg-gray-200 p-0 border-0 inline-flex items-center justify-center text-green-500 ml-4"
                      onClick={handleBuyClick}
                    >
                      Buy Now
                    </button>
                    {/* <button
                      className="rounded-full w-20 h-20 bg-gray-200 p-0 border-0 inline-flex items-center justify-center text-green-500 ml-4"
                      onClick={handleBuyClick}
                    >
                      Buy Now
                    </button> */}
                  </div>
                </div>
                <img
                  alt="ecommerce"
                  className="lg:w-1/2 w-full lg:h-auto h-64 object-cover object-center rounded"
                  src={`${axiosInstance.defaults.baseURL}/${product.image}`}
                />
              </div>
            )}
          </div>
        </section>
      </div>
    </div>
  );
}
